import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

import { JoinPage } from "~/pages/join/join.page";
import { setPendingOrgInviteId } from "~/stores/onboarding";

/**
 * Workspace invitation accept entry point (`/join?id=...`).
 */
export const Route = createFileRoute("/join/")({
  validateSearch: z.object({ id: z.string() }),
  beforeLoad: ({ context, search }) => {
    if (context.user?.onboarding !== "done") {
      setPendingOrgInviteId(search.id);
      throw redirect({ to: "/onboard", replace: true });
    }
  },
  component: JoinPage,
});
